import React, { FC, PropsWithChildren } from "react";
import styled, { css } from "styled-components";
import { PropsWithPropStyling, propStyling, tombac } from "../../../shared";
import { ButtonAddonHoverEffect } from "../Button";
import { Container } from "./Container";
import { HoverAnimation } from "./HoverAnimation";

export type AddonProps = PropsWithChildren<
  PropsWithPropStyling<{
    hoverEffect?: ButtonAddonHoverEffect;
    hoverEffectDelay?: string;
  }>
>;

export const Addon: FC<AddonProps> = ({
  children,
  hoverEffect = "none",
  hoverEffectDelay,
  ...stylingProps
}) => (
  <HoverAnimation delay={hoverEffectDelay} variant={hoverEffect}>
    <Content {...stylingProps}>{children}</Content>
  </HoverAnimation>
);

const Content = styled.span<PropsWithPropStyling>`
  ${({
    theme: {
      components: {
        button: { current },
      },
    },
  }) => css`
    all: initial;

    color: ${tombac.parse(current!.color)};
    cursor: inherit;
    font-size: ${tombac.unit(current!.fontSize!)};
    transition: 0.1s ease-out;
    transition-property: color, opacity;
    z-index: 1;

    ${Container}:hover && {
      color: ${tombac.parse(current!.hover?.color)};
    }

    ${Container}:disabled && {
      color: ${tombac.parse(current!.disabled?.color)};
    }

    ${propStyling}
  `}
`;
